/** @module SiteAdmin/LanguagesSwitchboard */
define([
	"dojo/_base/declare",
	"csi/toolbar/MultiSelectSwitchboard"
], function(declare, MultiSelectSwitchboard) {

	return declare(MultiSelectSwitchboard, {
		disableButtonAction: true,
		idViewProperty: "activeLanguages",

		canShowPlugin: function() {
			// summary: return true if there is a Language matrix
			return !!this.getView().attributeSpecs?.find({name: "Languages"});
		},

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: do nothing - idViewProperty handles it all
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		}
	});
});